import {
  SET_PROFILE,
  SET_NICKNAME,
  RESET_PROFILE_STATE,
  PROFILE_KEY,
  NICKNAME_KEY,
} from '../../types/profile.types'
import initialState from './state'

export default {
  [SET_PROFILE]: (state, payload) => {
    state[PROFILE_KEY] = payload
  },
  [SET_NICKNAME]: (state, payload) => {
    state[NICKNAME_KEY] = payload
  },
  [RESET_PROFILE_STATE]: (state) => {
    Object.assign(state, initialState())
  },
}
